import { Route } from '@angular/router';
import { MonitoringPermissions } from '@backoffice/shared/bo/util-permissions';
import { ngxPermissionsGuard } from 'ngx-permissions';
import { ManualServiceStartedGuard } from './guard/manual-service-started.guard';
import { HealthcheckComponent } from './healthcheck.component';

export const healthCheckRoute: Route = {
  path: 'healthcheck',
  component: HealthcheckComponent,
  canActivate: [ngxPermissionsGuard],
  canDeactivate: [ManualServiceStartedGuard],
  data: {
    permissions: {
      only: MonitoringPermissions.healthCheckAccess,
    },
  },
  children: [
    {
      path: 'preview/:id',
      loadChildren: () =>
        import('@clean-code/monitoring/feature-healthcheck-history').then(
          (mod) => mod.MonitoringFeatureHealthcheckHistoryModule
        ),
    },
  ],
};
